/*
 * @Author: guoxioaoxiao guoxiaoxiao01@longfor.com
 * @Date: 2024-11-06 15:14:52
 * @LastEditors: guoxioaoxiao guoxiaoxiao01@longfor.com
 * @LastEditTime: 2025-03-19 14:49:37
 * @FilePath: /qd-yunjing-web/src/api/modules/alarm.ts
 * @Description: 这是默认设置,请设置`customMade`,
 */
import {
  $request,
} from '@/utils/request';
import type {
  AlarmInfoType,
} from '@/types';
import servers from '../servers';

/**
 * @description: 获取报警列表
 */
export const getAlarmListRequest = (params = {}) => $request<ResponseData<AlarmInfoType[]>>({
  url: `${servers.base}/api/v1/alarm/list`,
  method: 'get',
  params,
});

/**
 * @description: 首页报警信息-获取报警列表
 */
export const getCockpit = (params = {}) => $request<ResponseData<AlarmInfoType[]>>({
  url: `${servers.base}/api/v1/yj/alarm/cockpit`,
  method: 'get',
  params,
});

/**
 * @description: 获取报价列表
 */
export const getAlarmList = (params = {}) => $request<ResponseData>({
  url: `${servers.base}/api/v1/yj/alarm/list`,
  method: 'get',
  params,
});

/**
 * @description: 获取查询条件
 */
export const getAlarmFilters = (params = {}) => $request<ResponseData>({
  url: `${servers.base}/api/v1/yj/alarm/list/filters`,
  method: 'get',
  params,
});
/**
 * @description: 报警导出
 */
export const alarmExport = (data = {}) => $request<ResponseData>({
  url: `${servers.base}/api/v1/yj/alarm/export`,
  method: 'post',
  responseType: 'blob',
  data,
});
export const alarmExportUrl = `${servers.base}/api/v1/yj/alarm/export`;

/**
 * @description: 详情
 */
export const alarmDetail = (params = {}) => $request<ResponseData>({
  url: `${servers.base}/api/v1/yj/alarm/detail`,
  method: 'get',
  params,
});
/**
 * @description:
 */
export const getOrderFollowDetails = (params = {}) => $request<ResponseData>({
  url: `${servers.base}/api/v1/yj/alarm/getOrderFollowDetails`,
  method: 'get',
  params,
});

/**
 * @description: 隔离
 */
export const isolateData = (data = {}) => $request<ResponseData>({
  url: `${servers.base}/api/v1/yj/alarm/isolate`,
  method: 'post',
  data,
});
/**
 * @description: 隔离恢复
 */
export const isolateRecover = (data = {}) => $request<ResponseData>({
  url: `${servers.base}/api/v1/yj/alarm/isolateRecover`,
  method: 'post',
  data,
});
/**
 * @description: 隔离详情
 */
export const isolateDetail = (params = {}) => $request<ResponseData>({
  url: `${servers.base}/api/v1/yj/alarm/isolateDetail`,
  method: 'get',
  params,
});
/**
 * @description: 隔离列表
 */
export const alarmSuppressionList = (params = {}) => $request<ResponseData>({
  url: `${servers.base}/api/v1/yj/alarm/alarmSuppressionList`,
  method: 'get',
  params,
});

/**
 * @description: 隔离详情
 */
export const getRealTimePageRequest = (data = {}) => $request<ResponseData>({
  url: `${servers.base}/api/v1/yj/alarm/realTimePage`,
  method: 'post',
  data,
});
